import { createSlice } from '@reduxjs/toolkit';
import { getVendorsData, getIntegratedVendorsData } from '../../api/vendors';
// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  data: {
    vendors: [],
    facilities: [],
    vendorContacts: [],
    integratedVendors: [],
  },
  events: [],
  openModal: false,
  selectedEventId: null,
  selectedRange: null,
};

const slice = createSlice({
  name: 'vendors',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getVendorDataSuccess(state, action) {
      state.isLoading = false;
      state.data = {...state.data, ...action.payload};
    },

    getIntegratedVendorsSuccess(state, action) {
      state.isLoading = false;
      state.data.integratedVendors = action.payload;
    },

    getVendorContactsSuccess(state, action) {
      state.isLoading = false;
      state.data ={...state.data, ...action.payload};
    },

    // GET EVENTS
    getEventsSuccess(state, action) {
      state.isLoading = false;
      state.events = action.payload;
    },

    // CREATE EVENT
    createEventSuccess(state, action) {
      const newEvent = action.payload;
      state.isLoading = false;
      state.events = [...state.events, newEvent];
    },

    // UPDATE EVENT
    updateEventSuccess(state, action) {
      state.isLoading = false;
      state.events = state.events.map((event) => {
        if (event.id === action.payload.id) {
          return action.payload;
        }
        return event;
      });
    },

    // DELETE EVENT
    deleteEventSuccess(state, action) {
      const eventId = action.payload;
      state.events = state.events.filter((event) => event.id !== eventId);
    },

    // SELECT EVENT
    selectEvent(state, action) {
      const eventId = action.payload;
      state.openModal = true;
      state.selectedEventId = eventId;
    },

    // SELECT RANGE
    selectRange(state, action) {
      const { start, end } = action.payload;
      state.openModal = true;
      state.selectedRange = { start, end };
    },

    // OPEN MODAL
    onOpenModal(state) {
      state.openModal = true;
    },

    // CLOSE MODAL
    onCloseModal(state) {
      state.openModal = false;
      state.selectedEventId = null;
      state.selectedRange = null;
    },
  },
});

// Reducer
export default slice.reducer;

export const { onOpenModal, onCloseModal, selectEvent, selectRange } = slice.actions;

export function getVendors() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await getVendorsData();
      dispatch(slice.actions.getVendorDataSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getIntegratedVendors() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await getIntegratedVendorsData();
      dispatch(slice.actions.getIntegratedVendorsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
